import convertHTMLToPlainText from '@/utils/convertHTMLToPlainText'

/**
 * This returns the plain text version of ckeditor content
 * @param editorRef
 * @returns string
 */
export default editorRef => {
  const editorData = convertHTMLToPlainText(editorRef?.getData() || '')
  return editorData?.trim()
}
